import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CheckOutState } from '@frontend/check-in-kiosk/feature/check-out/src';

@Component({
  selector: 'frontend-check-out',
  templateUrl: './check-out.component.html',
  styleUrls: ['./check-out.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CheckOutComponent {
  @Input() state: CheckOutState;
  @Output() save = new EventEmitter();

  checkOutForm = new FormGroup({
    tag: new FormControl('', [Validators.required, Validators.maxLength(8)]),
  });
}
